import React, { useState, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../Context/auth'; // Ajuste o caminho
import MenuLateral from '../Components/MenuPrincipal/MenuLateral'; // Ajuste o caminho
import '../Marcas/Marcas.css'; // Reutiliza CSS

function NovaEtapaProducao() {
    const { currentUser } = useAuth();
    const navigate = useNavigate();

    const [descricao, setDescricao] = useState('');
    const [sequencia, setSequencia] = useState(''); // Estado para sequência
    const [loading, setLoading] = useState(false);
    const [mensagem, setMensagem] = useState('');

    // Hook genérico para chamadas API
    const apiCall = useCallback(async (url, method = 'POST', data = null) => {
        if (!currentUser) throw new Error("Usuário não autenticado.");
        const token = await currentUser.getIdToken();
        const API_URL = process.env.REACT_APP_API_URL;
        const config = {
            method,
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
        };
        if (data) config.body = JSON.stringify(data);
        const response = await fetch(`${API_URL}${url}`, config);
        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.error || `Falha na requisição para ${url}`);
        }
        return response.json();
    }, [currentUser]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMensagem('');

        if (!descricao || sequencia === '') {
            setMensagem("Os campos Descrição e Sequência são obrigatórios.");
            return;
        }
        if (isNaN(parseInt(sequencia))) {
            setMensagem("O campo Sequência deve ser um número.");
            return;
        }

        setLoading(true);
        try {
            await apiCall('/api/etapas-producao', 'POST', {
                descricao: descricao.trim(),
                sequencia: parseInt(sequencia) // Envia como número
            });
            navigate('/app/etapas-producao'); // Navega para a lista
        } catch (error) {
            console.error("Erro ao adicionar etapa: ", error);
            setMensagem(error.message); // Exibe erro da API (ex: duplicado)
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="marcas-page-container" style={{ display: 'flex', paddingTop: 0 }}>
            <MenuLateral />
            <div className="content-with-sidebar">
                <div className="marcas-header">
                    <div className="d-flex align-items-center gap-3">
                        <button className="btn btn-link text-secondary p-0" onClick={() => navigate('/app/etapas-producao')} title="Voltar">
                            <i className="fas fa-arrow-left fa-lg"></i>
                        </button>
                        <h1 className="marcas-title m-0">
                            Nova <span className="highlight">Etapa de Produção</span>
                        </h1>
                    </div>
                </div>

                <main className="marcas-content">
                    {mensagem && (
                        <div className="alert alert-danger d-flex align-items-center mb-4" role="alert">
                            <i className="fas fa-exclamation-circle me-2"></i>
                            <div>{mensagem}</div>
                        </div>
                    )}

                    <form onSubmit={handleSubmit}>
                        <div className="form-card">
                            <h5 className="form-section-header">Informações da Etapa</h5>
                            <div className="row g-3">
                                {/* Campo Sequência */}
                                <div className="col-md-3">
                                    <label htmlFor="sequencia" className="form-label-custom">Sequência *</label>
                                    <input
                                        type="number"
                                        className="form-control form-control-custom"
                                        id="sequencia"
                                        value={sequencia}
                                        onChange={(e) => setSequencia(e.target.value)}
                                        required
                                        min="1"
                                        placeholder="Ex: 10, 20..."
                                    />
                                </div>
                                {/* Campo Descrição */}
                                <div className="col-md-9">
                                    <label htmlFor="descricao" className="form-label-custom">Descrição *</label>
                                    <input
                                        type="text"
                                        className="form-control form-control-custom"
                                        id="descricao"
                                        value={descricao}
                                        onChange={(e) => setDescricao(e.target.value)}
                                        required
                                        placeholder="Ex: Corte, Costura, Acabamento..."
                                        autoFocus
                                    />
                                </div>
                            </div>
                        </div>

                        {/* FIXED FOOTER Actions */}
                        <div className="form-actions-bar">
                            <Link to="/app/etapas-producao" className="btn-secondary-custom">
                                Cancelar
                            </Link>
                            <button type="submit" className="btn-primary-custom" disabled={loading}>
                                {loading ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                        Salvando...
                                    </>
                                ) : 'Salvar Etapa'}
                            </button>
                        </div>
                    </form>
                </main>
            </div>
        </div>
    );
}

export default NovaEtapaProducao;
